<template>
<!-- 招聘信息 -->
    <div class="YinshiOffcialwebsiteRecruitInfo">
        <div><el-button type="primary" size="small" @click="addRecruitInfo">添加</el-button></div> 
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="educationalRequirementsName" label="学历要求" min-width="70"></el-table-column>
            <el-table-column prop="jobTitle" label="岗位名称" min-width="70"></el-table-column>
            <el-table-column prop="workCity" label="工作城市" min-width="70"></el-table-column>
            <el-table-column prop="workAddress" label="工作地址" min-width="70"></el-table-column>
            <el-table-column prop="workExperienceMax" label="最长工作经验( 年)" min-width="70"></el-table-column>
            <el-table-column prop="workExperienceMin" label="最少工作经验(年)" min-width="70"></el-table-column>
            <el-table-column prop="jobRequirements" label="任职要求" min-width="300"></el-table-column>
            <el-table-column prop="jobDuty" label="岗位职责" min-width="300"></el-table-column>
            <el-table-column label="操作" min-width="100">
                <template slot-scope="scope" >
                    <el-button size="mini" @click="updataRecruitInfo(scope.row)">编辑</el-button>&ensp;
                    <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deleteRecruitInfo(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="title+'招聘信息'" :visible.sync="dialogFormVisible" class="personalInfo" width="29%">
            <div class="recruit">
                <el-form :model="operObj" ref="downloadObj">
                    <el-form-item label="学历要求" class="labelWidth" prop="name">
                        <el-select v-model="operObj.educationalRequirementsId" placeholder="请选择">
                            <el-option
                            v-for="item in educationalsList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="岗位名称" class="labelWidth">
                        <el-input v-model="operObj.jobTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="工作城市" class="labelWidth">
                        <el-input v-model="operObj.workCity"></el-input>
                    </el-form-item>
                    <el-form-item label="工作地址" class="labelWidth">
                        <el-input v-model="operObj.workAddress"></el-input>
                    </el-form-item>
                    <el-form-item label="最少工作经验(年)" class="labelWidth">
                        <el-input v-model="operObj.workExperienceMin"></el-input>
                    </el-form-item>
                    <el-form-item label="最长工作经验(年)" class="labelWidth">
                        <el-input v-model="operObj.workExperienceMax"></el-input>
                    </el-form-item>
                    <el-form-item label="岗位职责" class="labelWidth">
                        <el-input v-model="operObj.jobDuty" type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="任职要求" class="labelWidth">
                        <el-input v-model="operObj.jobRequirements" type="textarea"></el-input>
                    </el-form-item>
                    
                </el-form>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpdate">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// listJoinUs      查询招聘信息
// deleteJoinUs    删除招聘信息
// saveJoinUs      保存招聘信息
// updateJoinUs    修改招聘信息
// getListEducationals    查询学历
import { 
listJoinUs,
deleteJoinUs,
saveJoinUs,
updateJoinUs,
getListEducationals,} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteRecruitInfo',

    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            count:0,
            // 招聘信息
            tableData: [],
            title:'',
            dialogFormVisible:false,
            // 要修改或者要增加
            operObj:{
                educationalRequirementsId:'',
                jobDuty:'',
                jobTitle:'',
                workCity:'',
                workAddress:'',
                workExperienceMax:'',
                workExperienceMin:'',
                jobRequirements:'',
                id:'',
            },
            // 学历
            educationalsList:[],
        };
    },

    mounted() {
        
    },
    watch:{
        educationalsList(){
            this.selectRecruitInfo()
        }
    },
    methods: {
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectRecruitInfo()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectRecruitInfo()
        },
        // 查询学历
        async selectEducationals(){
            let etl = await getListEducationals()
            if(etl.code == 200){
                this.educationalsList = etl.data
            }
        },
        // 查询招聘信息列表
        async selectRecruitInfo(){
            let res = await listJoinUs({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            // 学历信息
            if(res.code == 200){
                res.data.forEach(item => {
                    this.educationalsList.forEach(item2 => {
                        if(item.educationalRequirementsId == item2.id){
                            item.educationalRequirementsName = item2.name
                        }
                    })
                })
                this.count = res.page.count
            }
            this.tableData = res.data
        },
        // 删除
        async deleteRecruitInfo(id){
            let res = await deleteJoinUs(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectRecruitInfo()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
        // 修改企业信息
        async updataRecruitInfo(obj){
            this.dialogFormVisible = true
            Object.keys(obj).forEach(key1 => {
                Object.keys(this.operObj).forEach(key2 => {
                    if(key1 == key2){
                        this.operObj[key2] = obj[key1] 
                    }
                })
            })
            this.title = '修改'
        },
        // 新增
        addRecruitInfo(){
            Object.keys(this.operObj).forEach(key => {
                this.operObj[key] = ''
            })
            this.title = '新增'
            this.dialogFormVisible = true

        },
        // 提交修改
        async submitUpdate(){
            let res;
            if(this.title == '修改'){
                res = await updateJoinUs(this.operObj);
            }else{  //新增
                res = await saveJoinUs(this.operObj);
            }
            if(res.code == 200){
                this.$message({ message: this.title+'成功！', type: 'success' });
                this.selectRecruitInfo()
                this.dialogFormVisible = false
            }else{
                if(res.data){
                    this.$message({message: res.data+'！',type: 'error'});
                }else{
                    this.$message({message: this.title+''+res.msg+'！',type: 'error'});
                }
            }


        }
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectEducationals()
    }
};
</script>

<style lang="scss">
.YinshiOffcialwebsiteRecruitInfo .personalInfo .recruit{
    .el-form-item__label{
        width: 120px !important;
    }
    .el-form-item__content{
        width: 300px !important;
    }
}
</style>
<style lang="scss" scoped>
// 分页
.pagination{
    padding: 50px 270px 30px 270px;
    text-align: center;
}
</style>